<template>
  <div class="block-wrap">
    <div class="block"  style="margin: auto;width: 800px">
      <a href="http://www.yuncargo.cn/" target="_blank">
        <el-image
          :src="specImages"></el-image>
      </a>

    </div>
    <div style="display: flex;margin-bottom: 30px;margin-top: 30px">
      <el-input v-model="input"
                placeholder="请输入订单号"
                style="max-width: 500px;margin: auto"
                @change="handleSearch"
      >
        <el-button slot="append"
                   style="background-color: #3a8ee6;color: white"
                   icon="el-icon-search"
                   @click="handleSearch"
        >查找</el-button>
      </el-input>
    </div>
    <el-timeline style="width: 800px;margin: auto">
      <el-timeline-item v-for="(status, index) in statusData"
                        :key="index"
                        :timestamp="status.updateTime"
                        placement="top"
                        size="large"
                        :color=color
      >
        <el-card style="background-color: #DCDCDC">
          {{status.brief}}
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import indexImg from "../../assets/indexImgs/index.jpg";
export default {
  name: "StatusList",
  data() {
    return {
      input: '',
      color: "#0bbd87",
      statusData: [],
      specImages: [
        indexImg
      ]
    }
  },
  mounted() {
    this.input = this.$route.query.orderNr;
    this.handleSearch();
  },
  methods:{
    handleSearch() {
      this.$http.get("/status/findByOrder?orderNr=" + this.input).then(res => {
        if (res.data.code === 200) {
          this.statusData = res.data.data
        } else {
          this.$message.error(res.data.msg);
          this.statusData = []
        }
      });
    },
  }
}
</script>

<style scoped>
.block-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /*background-image: url("../../assets/indexImgs/1.jpg");*/
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/status/StatusList.vue